import './CartFulfilmentOption.scss';

import { object } from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getAvailabilityStoresSelector } from '@redux/reducers/bopis/getAvailabilityStores/selector';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { DELIVERY_OPTION } from '@utils/constant';
import { useDidUpdateEffect } from '@utils/customsHook/useDidUpdateEffect';

import { useCheckDeliveryOption, useFetchAvailabilityStores, useMappingDeliveryOptions, useUpdateDeliveryOption } from './hooks';
import RadioOption from './RadioOption';

const CartFulfilmentOption = ({ dataSources }) => {
  const currentCartLines = useSelector(state => state.productReducer.cartDetailReducer.currentCart?.Lines) || [];
  const { data: bopisAvailabilityStore } = useSelector(getAvailabilityStoresSelector);
  const deliveryOptions = useMappingDeliveryOptions();
  const updateDeliveryOptionService = useUpdateDeliveryOption();

  const {
    isLineExistOptionNotBOPIS,
    isBOPISOptionSelected
  } = useCheckDeliveryOption();
  const fetchAvailabilityStoresService = useFetchAvailabilityStores();

  const isAllowSelectBOPIS = useMemo(
    () => deliveryOptions.length
      && deliveryOptions.every((delivery) => !delivery.isDisabled),
    [deliveryOptions]
  );
  const firstLineInCart = useMemo(() => currentCartLines?.[0], [currentCartLines]);

  useEffect(() => {
    if (isAllowSelectBOPIS) {
      fetchAvailabilityStoresService(currentCartLines);
    }
  }, [isAllowSelectBOPIS, JSON.stringify(currentCartLines)]);

  useEffect(() => {
    if (!isAllowSelectBOPIS) {
      handleSelectDefaultDelivery();
    }
  }, [isAllowSelectBOPIS]);

  useDidUpdateEffect(() => {
    /** INFO: set default delivery option when BOPIS is selected but store availability list is empty */
    if (!bopisAvailabilityStore?.length) {
      const deliveryOptions = firstLineInCart?.DeliveryOptions;
      const selectedDeliveryOption = deliveryOptions?.find(option => option.ExternalId === firstLineInCart?.DeliveryOptionId);

      if (selectedDeliveryOption?.ShippingOptionType?.Value === DELIVERY_OPTION.PickUpStore || isBOPISOptionSelected && isLineExistOptionNotBOPIS) {
        handleSelectDefaultDelivery();
      }
    }
  }, [bopisAvailabilityStore, firstLineInCart, isBOPISOptionSelected, isLineExistOptionNotBOPIS]);

  useDidUpdateEffect(() => {
    /** INFO: set default delivery option when add new BOPIS product to cart */
    if (bopisAvailabilityStore?.length) {
      const deliveryOptions = firstLineInCart?.DeliveryOptions;
      const selectedDeliveryOption = deliveryOptions?.find(option => option.ExternalId === firstLineInCart?.DeliveryOptionId);

      if (currentCartLines.some((cartLineItem) => selectedDeliveryOption.ExternalId !== cartLineItem?.DeliveryOptionId)) {
        updateDeliveryOptionService(selectedDeliveryOption);
      }
    }
  }, [bopisAvailabilityStore, firstLineInCart, isBOPISOptionSelected, isLineExistOptionNotBOPIS]);

  function handleSelectDefaultDelivery () {
    const availableDeliveryOptionsList = deliveryOptions.filter((option) => option?.ShippingOptionType?.Value
      !== DELIVERY_OPTION.PickUpStore);
    if (availableDeliveryOptionsList?.length) {
      const shippingOption = availableDeliveryOptionsList.find((option) => option?.ShippingOptionType?.Value
        === DELIVERY_OPTION.ShipItem);
      if (shippingOption) {
        updateDeliveryOptionService(shippingOption);
      } else {
        updateDeliveryOptionService(availableDeliveryOptionsList?.[0]);
      }
    }
  }

  return (
    <div className='cart-fulfilment-option animated-slow fadeIn delay-100'>
      <div className='container'>
        <div className='cart-fulfilment-option__wrapper'>
          <Text
            tag='h6'
            field={dataSources['Fulfillment Option Label']}
            className='large-text cart-fulfilment-option__title'
          />
          <ul className='cart-fulfilment-option__list cart-item-delivery__option'>
            {deliveryOptions.map((deliveryItem, deliveryIdx) => (
              <RadioOption
                key={deliveryItem.ExternalId}
                dataSources={dataSources}
                deliveryItem={deliveryItem}
                deliveryIdx={deliveryIdx}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

CartFulfilmentOption.propTypes = {
  dataSources: object
};

export default CartFulfilmentOption;